import { useJobQuery } from "@shared/services/jobs/hooks";
import { BacktestingRunType, BacktestingStatus } from "@shared/types";
import { useMemo } from "react";
import { jobStatusToBacktestStatus } from "@shared/features/bots/BotForm/Backtesting/utils";

interface UseLiveBacktestingProps {
  data?: BacktestingRunType;
}

const useLiveBacktesting = ({ data }: UseLiveBacktestingProps) => {
  const jobQueryStatus = useJobQuery(
    data?.status === BacktestingStatus.IN_PROGRESS ? data?.job_id : undefined
  );
  const liveBacktestingData =
    jobQueryStatus.data?.data.backtesting_run_data ?? data;
  const liveStatus = jobQueryStatus.data?.status;

  const status = useMemo(() => {
    return jobStatusToBacktestStatus(data?.status, liveStatus);
  }, [liveStatus, data?.status]);

  const inProgress = status === BacktestingStatus.IN_PROGRESS;

  return {
    liveBacktestingData,
    status,
    inProgress,
  };
};

export default useLiveBacktesting;
